export const meta = {
  title: 'node-exporter',
  defaults: { port: 9100, version: '1.8.2', listen: '0.0.0.0' },
};
